"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolbox_redux_framework_1 = require("@zapier/toolbox-redux-framework");
const toolbox_browser_fetch_1 = require("@zapier/toolbox-browser-fetch");
const ResourceUrls_1 = require("../utils/ResourceUrls");
function fetchZap(id, { isTemplate } = { isTemplate: false }) {
    return toolbox_browser_fetch_1.fetchJson(ResourceUrls_1.getZapUrl({ id, isTemplate })).catch(response => {
        throw new toolbox_redux_framework_1.commonErrors.DataGetError({
            resource: toolbox_redux_framework_1.resourceNames.zap,
            response,
        });
    });
}
exports.default = fetchZap;
